module.exports = __webpack_public_path__ + "img/general.589c0112.png";